import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, InputWithLabel, Text } from '@reveni-io/reveni-ui'

const ReasonField = ({ value, onChange, disabled, placeholder, error, infoText }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <Text type="bodyMBold">{t('Motivo')}</Text>
      <InputWithLabel
        label={t('Motivo')}
        placeholder={placeholder}
        value={value || ''}
        onChange={onChange}
        maxLength={50}
        showCounter
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={error}
        helperText={error ? t('Este campo es obligatorio') : undefined}
      />
      <Alert type="info">
        {infoText ||
          t('El motivo se mostrará en la alerta correspondiente para aclarar por qué el reembolso se puso en espera.')}
      </Alert>
    </>
  )
}

export default ReasonField
